import { oiauth } from "../../../../environments/auth";
import { SigninRedirectArgs, UserManager, UserManagerSettings } from "oidc-client-ts";

const settings: UserManagerSettings = oiauth;

export const userManager = new UserManager(settings);

export function getUser()
{
    return userManager.getUser();
}

export function login(email?: string)
{
    const additional: SigninRedirectArgs = {
        extraQueryParams: {
            // "origin": window.location.origin
        }
    };

    if(email)
    {
        additional.extraQueryParams = {
            ...additional.extraQueryParams,
            "username": email
        };
    }

    return userManager.signinRedirect(additional);
}

export function renewToken()
{
    return userManager.signinSilent();
}

export async function logout(additional?: () => void)
{
    sessionStorage.removeItem("version");
    if(additional)
    {
        try
        {
            additional();
        }
        catch(err)
        {
            console.error("Could not run additional logout funcion", err);
        }
    }
    const data = await getUser();
    return userManager.signoutRedirect({
        id_token_hint: data?.id_token,
        post_logout_redirect_uri: `${window.location.origin}/signout-callback`
    });
}
